import './index.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App.tsx';
import { makerVariantReady } from './variant-resolver.tsx';

const mkrRoot = ReactDOM.createRoot(document.getElementById("cmnhj2ahv00de0z0y1cq7bf09-root")!);
makerVariantReady().then(() => {
  mkrRoot.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
});

// Default export of the app entry to satisfy the Maker entry-default-export contract.
export default App;
